/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IAppState } from '../../../core/store/state';
import {
  getMapModuleLoaded,
  getMapOptionsModuleLoaded,
  getOverlayControlsModuleLoaded,
  getSidePanelContent
} from '../../../core/store/selectors';
import { ESidePanelContent } from '../../../core/models';

@Component({
  selector: 'fm-map-overlay-container',
  templateUrl: './default-overlays-container.component.html',
  styleUrls: ['./default-overlays-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultOverlaysContainerComponent implements OnInit {
  public isMapLoaded$: Observable<boolean>;
  public isMapOptionsLoaded$: Observable<boolean>;
  public isOverlayControlsLoaded$: Observable<boolean>;
  public sidePanelContent$: Observable<ESidePanelContent>;

  ESidePanelContent = ESidePanelContent;

  constructor(private readonly _store: Store<IAppState>) {}

  ngOnInit(): void {
    this.isMapLoaded$ = this._store.pipe(select(getMapModuleLoaded));
    this.isMapOptionsLoaded$ = this._store.pipe(select(getMapOptionsModuleLoaded));
    this.isOverlayControlsLoaded$ = this._store.pipe(select(getOverlayControlsModuleLoaded));
    this.sidePanelContent$ = this._store.pipe(select(getSidePanelContent));
  }
}
